import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { PaginatedItem } from '../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeStory } from '../../drupal/types_and_parser/types'
import { getPage } from '../drupalPage/api'
import { Page } from '../drupalPage/state'
import { removeLangFromUrl } from '../utils/history.mod'
import { getOverview } from './api'

export type StoryOverviewState = {
  overview_page: number
  storyPage: AsyncState<Page>
  get_stories: AsyncState<PaginatedItem<ParsedNodeStory>>
}

export const initialStoryOverviewState = (lang: string, page: number): StoryOverviewState => ({
  overview_page: page,
  storyPage: loadingAsyncState(() => getPage(removeLangFromUrl(window.location.pathname))),
  get_stories: loadingAsyncState(() => getOverview<ParsedNodeStory>('stories-overview', lang, page))
})
